import cx from 'classnames';
import React, {memo} from 'react';
import IconButton, {IconButtonProps} from '@material-ui/core/IconButton';

import {useStyles} from './Month.styles';

export interface MonthProps extends IconButtonProps {
    singleSelect?: boolean;
    preselected?: boolean;
    rangeStart?: boolean;
    rangeEnd?: boolean;
    inRange?: boolean;
    selected?: boolean;
    disabled?: boolean;
    children: string;
}

const Month = ({
    singleSelect,
    preselected,
    rangeStart,
    rangeEnd,
    inRange,
    selected,
    disabled,
    ...props
}) => {
    const classes = useStyles();

    return (
        <div
            className={cx(classes.cell, {
                [classes.range]: !singleSelect,
                [classes.rangeEndPreselected]: !singleSelect && preselected,
                [classes.rangeStart]: rangeStart,
                [classes.rangeEnd]: rangeEnd,
                [classes.rangeSelected]: inRange,
                [classes.rangePreselected]: inRange && preselected
            })}>
            <IconButton
                component="div"
                disabled={disabled}
                className={cx(classes.monthButton, {
                    [classes.monthButtonSelected]: selected,
                    [classes.monthButtonPreselected]: selected && preselected
                })}
                {...props}
            />
        </div>
    );
};

export default memo(Month);
